import { useState } from 'react';
import { fetchTracking, TrackingResult } from '../../services/trackingService';
import { carrierLabel } from '../../types/carriers';
import styles from './TrackingPanel.module.scss';

interface TrackingPanelProps {
  orderId: string;
  proofToken?: string | null;
  carrier?: string | null;
  trackingNumber?: string | null;
}

function TrackingPanel({ orderId, proofToken, carrier, trackingNumber }: TrackingPanelProps) {
  const [result, setResult] = useState<TrackingResult | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  if (!trackingNumber) {
    return (
      <div className={styles.panel}>
        <span className={styles.eyebrow}>배송 조회</span>
        <p className={styles.notice}>배송정보 준비 중입니다.</p>
      </div>
    );
  }

  const handleCheck = async () => {
    if (!proofToken) return;
    setError(null);
    setIsLoading(true);
    try {
      const data = await fetchTracking(orderId, proofToken);
      setResult(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : '배송 조회 중 오류가 발생했습니다.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.panel}>
      <span className={styles.eyebrow}>배송 조회</span>
      <div className={styles.summary}>
        <span className={styles.carrier}>{carrierLabel(carrier)}</span>
        <span className={styles.invoice}>{trackingNumber}</span>
        <button type="button" className={styles.checkButton} onClick={handleCheck} disabled={!proofToken || isLoading}>
          {isLoading ? '조회 중...' : '배송조회'}
        </button>
      </div>

      {error && <p className={styles.error}>{error}</p>}
      {result && !result.available && <p className={styles.notice}>배송정보 준비 중입니다.</p>}
      {result && result.available && (
        <div className={styles.result}>
          <p className={styles.state}>
            {result.completed ? '배송 완료' : '배송 중'}
            {result.lastState && ` · ${result.lastState}`}
          </p>
          {result.lastUpdatedAt && <p className={styles.meta}>최근 업데이트: {result.lastUpdatedAt}</p>}
        </div>
      )}
    </div>
  );
}

export default TrackingPanel;
